import { RoutingConstants } from './consts/RoutingConstants';

export const GenerateEnquryLink = (orderLineId: number | string) =>
  `${RoutingConstants.SupportTickets}/${RoutingConstants.SupportTickets_Raise}/${orderLineId}`;
